export const LANGUAGES = [
  { code: "en", label: "ENG" },
  { code: "fr", label: "FRE" },
  { code: "ar", label: "AR" },
  { code: "pt", label: "POR" },
  { code: "sw", label: "SWA" },
];
